module.exports = __webpack_public_path__ + "static/media/do.07d2b1ed.svg";